import { Layout } from 'antd';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import React from 'react';
import styles from './style.module.scss';

interface LoginLayoutProps extends RouteComponentProps {
  children: React.ReactNode;
}

class LoginPageLayout extends React.PureComponent<LoginLayoutProps> {
  state = {
    backgroundNumber: 1,
    backgroundEnabled: false,
  };

  render() {
    const { children } = this.props;
    const { backgroundNumber, backgroundEnabled } = this.state;

    return (
      <Layout>
        <Layout.Content>
          <div
            className={backgroundEnabled ? `${styles.layout} ${styles.light}` : `${styles.layout}`}
            style={{
              backgroundImage: backgroundEnabled
                ? `url('resources/images/photos/${backgroundNumber}.jpeg')`
                : `none`,
            }}
          >
            <div className={styles.header} />
            <div className={styles.content}>{children}</div>
            <div className={`${styles.footer} text-center`}>
              <p>&copy; 2019 - {new Date().getFullYear()} Wahed Inc. All rights reserved.</p>
            </div>
          </div>
        </Layout.Content>
      </Layout>
    );
  }
}

export const LoginLayout = withRouter(LoginPageLayout);
